import React, { Component } from 'react';
import { Layout, Divider } from 'antd';
import "antd/dist/antd.css";
import './home.css';
import '../components/css/bar.css';
import {Route, Switch, Redirect, Link} from "react-router-dom";
import {routes} from "../../router";
import PrivateRoute from "../../privateRoute";
import {usfLogout,externalLogout,sapLogout} from "../../requist";

const { Content, Footer } = Layout;

class home extends Component{
    constructor(props) {
        super(props);
        this.state={
            showSider:true,
            userInfo:null
        }
    }
    Logout=()=>{
        let userType = window.localStorage.getItem('userType')
        window.localStorage.removeItem('userId');
        window.localStorage.removeItem('pcsBpId');
        window.localStorage.removeItem('dcgBpId');
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('menuList');
        if('internal' === userType){
            usfLogout().then(res=>{
                window.location.href = res;
                window.localStorage.removeItem('userToken');
                window.localStorage.removeItem('lenovoid');
                window.localStorage.removeItem('sst');
            })
        } else if('external'===userType) {
            window.localStorage.removeItem('userToken');
            window.localStorage.removeItem('lenovoid');
            window.localStorage.removeItem('sst');
            externalLogout().then(res=>{
                window.location.href = res;
            })
        } else if('sap' === userType){
            //sap退出
            sapLogout()
            window.localStorage.removeItem('userToken');
            window.localStorage.removeItem('lenovoid');
            window.localStorage.removeItem('sst');
            window.location.href = "/disputeHome"
        } else {
            window.location.href = "/disputeHome"
        }
    }

    componentDidMount() {
        let that = this;
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if(userInfo){
            that.setState({userInfo:userInfo})
        }
        window.addEventListener("setItemEvent", function (e) {
            let item = JSON.parse(window.localStorage.getItem('userInfo'));
            if(item){
                that.setState({userInfo:item})
            }
        });
    }

    render() {
        // let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        let {userInfo}=this.state;
        return <div>
                <Layout>
                    <div className="header-box">
                        <Link to={'/disputeHome'} className="logo"></Link>
                        <b style={{color:'#dc291e',fontSize:'22px'}}>BUSINESS PARTNERS DISPUTE PORTAL</b>
                        <div className={'loginOut'}>
                            <img src="assets/Avatar.jpg" alt=""/>
                            {userInfo? < b > {userInfo.requestorID}</b>:''}
                            {userInfo? <a href="#/" onClick={this.Logout}>Logout</a>:''}
                        </div>
                    </div>
                    <Content style={{background:"#fff"}}>
                        <Switch>
                            <Route path="/" exact={true} strict={true} component={() => <Redirect to="/disputeHome"/>}/>
                            {routes.map((item, index) => {
                                return <PrivateRoute key={index} {...item} />
                            })}
                        </Switch>
                    </Content>
                    {
                        userInfo?
                            <Footer className='footer'>
                                <a target="_blank" rel="noreferrer" href="https://www.lenovo.com/gb/en/legal/copyright-and-trademark-info/">© 2021 Lenovo. All rights reserved.</a>
                                <Divider type="vertical" dashed={true} style={{borderColor:'#999'}}/>
                                <a target="_blank" rel="noreferrer" href="https://www.lenovo.com/gb/en/legal/">Terms of use</a>
                                <Divider type="vertical" dashed={true} style={{borderColor:'#999'}}/>
                                <a target="_blank" rel="noreferrer" href="https://www.lenovo.com/gb/en/privacy/">Privacy</a>
                            </Footer>:''
                    }
                </Layout>

        </div>
    }
}

export default home;